
import { useState } from 'react';
import { CivicEducationItem } from '@/types/civic-education';
import { createUniqueId } from '@/lib/utils';

export const useDialogManagement = (contentType: string) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState<CivicEducationItem | null>(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleOpenDialog = (item?: CivicEducationItem) => {
    if (item) {
      setCurrentItem(item);
      setIsEditing(true);
    } else {
      const newItemType = contentType !== 'all' ? contentType as 'podcast' | 'video' | 'summary' : 'podcast';
      
      let newItem: CivicEducationItem;
      const baseItem = {
        id: createUniqueId(),
        title: '',
        description: '',
        date: new Date().toISOString().split('T')[0],
        tags: [],
        related_issues: [],
        status: 'draft' as const,
        country_code: null,
        type: newItemType,
      };
      
      if (newItemType === 'podcast') {
        newItem = {
          ...baseItem,
          type: 'podcast',
          episode_id: '',
        };
      } else if (newItemType === 'video') {
        newItem = {
          ...baseItem,
          type: 'video',
          video_id: '',
        };
      } else {
        newItem = {
          ...baseItem,
          type: 'summary',
          document_url: '',
          source: '',
          content: '',
        };
      }
      
      setCurrentItem(newItem);
      setIsEditing(false);
    }
    setDialogOpen(true);
  };

  return {
    dialogOpen,
    setDialogOpen,
    currentItem,
    setCurrentItem,
    isEditing,
    handleOpenDialog
  };
};
